export const formatTime = (timeInSeconds?: number | null): string => {
  if (!timeInSeconds) {
    return '-';
  }

  const minutes = Math.floor(timeInSeconds / 60);
  const hours = Math.floor(timeInSeconds / 3600);
  const days = Math.floor(timeInSeconds / 86400);

  if (minutes < 60) {
    return `${minutes}m`;
  } else if (hours < 24) {
    const remainingMinutes = minutes % 60;
    if (remainingMinutes === 0) {
      return `${hours}h`;
    }
    return `${hours}h ${remainingMinutes}m`;
  } else {
    const remainingHours = hours % 24;
    if (remainingHours === 0) {
      return `${days}d`;
    }
    return `${days}d ${remainingHours}h`;
  }
};
